module.exports = __webpack_public_path__ + "img/products_1.2ac68d9f.png";